export default "__VITE_ASSET__GZkgJk_4__"